module.exports = __webpack_public_path__ + "images/icono-3-musculos-mas-grande.jpg";